// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ii-0";
export var actionModalContentContainer = "_ii-1";
export var createTagButton = "_ii-2";
export var footerContainer = "_ii-7";
export var fullWidthDivider = "_ii-3";
export var hasCreateTagButton = "_ii-4";
export var noCreateTagButton = "_ii-5";
export var tagsContainer = "_ii-6";
export var tagsModalContentContainer = "_ii-8";